/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePalSubmissionRequest
 */
export interface CreatePalSubmissionRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreatePalSubmissionRequest
     */
    is_oon: boolean;
}

/**
 * Check if a given object implements the CreatePalSubmissionRequest interface.
 */
export function instanceOfCreatePalSubmissionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_oon" in value;

    return isInstance;
}

export function CreatePalSubmissionRequestFromJSON(json: any): CreatePalSubmissionRequest {
    return CreatePalSubmissionRequestFromJSONTyped(json, false);
}

export function CreatePalSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_oon': json['is_oon'],
    };
}

export function CreatePalSubmissionRequestToJSON(value?: CreatePalSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_oon': value.is_oon,
    };
}

